{
  "sources": ["meischke-burgerweeshuis-huizen", "painting-1538", "woodcut-1544"],
  "note": "Meischke chapter 5, pp. 310 and 320–323, distinguishes the old corner property later numbered Kalverstraat 78, its four alley-facing rear homes, and the neighbouring properties 80, 82 and 84. The corner is documented in 1422 and 1452, the division of 80/82 and their shared rear access by 1500/1501, and the narrow 84 property by 1480. The four rear homes are documented in 1559/1562; using their sequence and the later 1651 frontage proportions for 1538 is inferred. Their reported length equals the corner frontage, 19.5 feet; metre dimensions here are fitted estimates. House chainages, footprints, shear, heights, pitch, gables, openings and private-ground edges are estimates, not a measured 1538 parcel survey or eight individually identified painting roofs. The unexecuted 1651–1652 widening scheme, 1716 replacement, 1750 fronts and enlarged rear sheds are excluded.",
  "rows": [
    {
      "id": "kalver-corner-alley",
      "source": "street-sint-luciensteeg-2",
      "side": "right",
      "from": 31.1,
      "to": 49.34,
      "depth": 5.5,
      "shear": 0,
      "storeyHeight": 3.15,
      "houses": [
        {
          "id": "kalver-corner-rear-4",
          "widthWeight": 17.5
        },
        {
          "id": "kalver-corner-rear-3",
          "widthWeight": 18
        },
        {
          "id": "kalver-corner-rear-2",
          "widthWeight": 13
        },
        {
          "id": "kalver-corner-rear-1",
          "widthWeight": 15.5
        }
      ]
    },
    {
      "id": "kalver-corner-84",
      "source": "street-kalverstraat",
      "side": "left",
      "from": 176.3,
      "to": 182.1,
      "depth": 16,
      "shear": -1.1,
      "storeyHeight": 3.9,
      "houses": [
        {
          "id": "kalver-corner-house-84",
          "widthWeight": 1
        }
      ]
    },
    {
      "id": "kalver-corner-82",
      "source": "street-kalverstraat",
      "side": "left",
      "from": 182.1,
      "to": 188.3,
      "depth": 15,
      "shear": -1.1,
      "storeyHeight": 4.1,
      "houses": [
        {
          "id": "kalver-corner-house-82",
          "widthWeight": 1
        }
      ]
    },
    {
      "id": "kalver-corner-80",
      "source": "street-kalverstraat",
      "side": "left",
      "from": 188.3,
      "to": 194.8,
      "depth": 16,
      "shear": -1.1,
      "storeyHeight": 4.1,
      "houses": [
        {
          "id": "kalver-corner-house-80",
          "widthWeight": 1
        }
      ]
    },
    {
      "id": "kalver-corner-78",
      "source": "street-kalverstraat",
      "side": "left",
      "from": 194.8,
      "to": 200.3,
      "depth": 5.5,
      "shear": -0.58,
      "storeyHeight": 3.9,
      "houses": [
        {
          "id": "kalver-corner-house-78",
          "widthWeight": 1
        }
      ]
    }
  ],
  "privateGround": [
    [-90.05, -295.17],
    [-89.82, -266.4],
    [-80.01, -263.91],
    [-76.42, -263.0],
    [-72.22, -261.94],
    [-63.2, -259.69],
    [-66.49, -271.15],
    [-69.81, -282.68]
  ]
}
